export const trigger = (element, eventType, isChecked) => {
	if ( element.checked !== undefined && isChecked !== undefined )
	{
		element.checked = isChecked;
	}
	
	const event = document.createEvent(`Event`);
	event.initEvent(eventType, false, true);
	element.dispatchEvent(event);
};
